import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { PermissionService } from '../../../services/permission.service';
import { IDocumentoModalData } from './modal-documento-layout.model';
@Component({
  selector: 'app-modal-documento-layout',
  templateUrl: './modal-documento-layout.component.html',
  styleUrls: ['./modal-documento-layout.component.scss'],
})
export class ModalDocumentoLayoutComponent implements OnInit {
  @Input() documentoData: IDocumentoModalData = {};
  @Output() inputClose = new EventEmitter<boolean>();
  base64Prefix: string = 'data:image/jpeg;base64,';
  visible: boolean = true;

  constructor(
    private permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.permissionService.getPermission();
    this.changeDetectorRef.detectChanges();
  }
}
